export default __webpack_public_path__ + "static/media/image30.c8f0dac4.png";